import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import HCaptcha from '@hcaptcha/react-hcaptcha'

//Material UI Imports
import LockOpenIcon from '@material-ui/icons/LockOpen'
import LaunchIcon from '@material-ui/icons/Launch';
import CardContent from '@material-ui/core/CardContent'
import Button from '@material-ui/core/Button'
import { FormControl, IconButton, InputAdornment, TextField } from '@material-ui/core'
import FormHelperText from '@material-ui/core/FormHelperText'
import Link from '@material-ui/core/Link'
import { useSnackbar } from 'notistack'
import Divider from '@material-ui/core/Divider'
import Visibility from '@material-ui/icons/Visibility'
import VisibilityOff from '@material-ui/icons/VisibilityOff'


//Redux
import allActions from '../../redux/actions/user'

export default function LogIn(props) {
  const urlTokenValue = new URLSearchParams(location.search).get('tokenSSO');

  const dispatch = useDispatch()
  const { enqueueSnackbar } = useSnackbar()
  const history = useHistory()

  const classes = props.styles

  const [logIn, setLogIn] = useState({ numero: '', password: '' })

  const [errorNumero, setErrorNumero] = useState({ value: false, text: '' })
  const [errorsPassword, setErrorsPassword] = useState({ value: false, text: '' })
  const [errorCaptcha, setErrorCaptcha] = useState({ value: false, text: '' })
  const [errorForm, setErrorForm] = useState({ value: false, text: '' })

  const [showPassword, setShowPassword] = useState(false)
  const [captchaValid, setCaptchaValid] = useState(false)

  const numeroRegex = /^\d{8}$/

  /**
   * Méthode appelée à chaque changement du formulaire
   * @param {*} e : event
   */
  function handleChange(e) {
    let newLogIn = logIn
    newLogIn[e.target.name] = e.target.value
    setLogIn(newLogIn)
  }


  /**
   * Méthode appelée au click du bouton "Se connecter"
   */
  async function submit(e) {

    e.preventDefault()

    //Netoyage des erreurs
    setErrorForm({ value: false, text: '' })

    //Vérifie la validité des champs du formulaire
    const valid = checkValid()
    if (!valid) return

    //Appel vers l'API

    const body = { numero: logIn.numero, password: logIn.password }
    const result = await allActions.fetchPostAPI('api/auth/login', body, dispatch)

    //Si la requête n'a pas fonctionnné une erreur est affiché
    if (result.err) {
      setErrorForm({ value: true, text: 'Erreur: ' + result.err })
      return
    }

    const { res, json } = result


    //Si le serveur retourne une erreur elle est affiché
    if (!res.ok) {
      setErrorForm({ value: true, text: 'Erreur: ' + json.message })
      return
    }

    const result2 = await allActions.fetchGetAPI('api/users/modifs-infos-perso/' + json.licencie.id, dispatch, json.accessToken)
    var info = result2.json.data
    var redirectInfoPerso = true

    if (info) {
      if (info[0]?.civilite && info[0]?.nom && info[0]?.prenom && info[0]?.profession && info[1]?.date && info[2]?.adresseL1 && info[2]?.adresseNum && info[2]?.codePostal && info[2]?.ville && info[3]?.phone && info[3]?.email && info[4]?.centre) {
        dispatch(allActions.setDataCompleted(true))
        redirectInfoPerso = false
      }
      else
        dispatch(allActions.setDataCompleted(false))
    }

    //Mise à jour du state user Redux
    dispatch(allActions.setUser(json.licencie, json.accessToken))
    dispatch(allActions.logIn())

    //Redirige sur la page d'accueil

    if (redirectInfoPerso)
      history.push('/donnees-personnelles')
    else
      history.push('/')

  }

  /**
   * Vérifie la validité des champs du formulaire
   */
  function checkValid() {

    let isValid = true

    //Vérifie que le mail n'est pas vide et qu'il match avec la regex mail
    if (logIn.numero === '') {
      setErrorNumero({ value: true, text: 'Requis' })
      isValid = false
    } else if (!logIn.numero.match(numeroRegex)) {
      setErrorNumero({ value: true, text: 'Le numero d\'abonné doit contenir 8 chiffres' })
      isValid = false
    } else {
      setErrorNumero({ value: false, text: '' })
    }

    //Vérifie que le mot de passe n'est pas vide
    if (logIn.password === '') {
      setErrorsPassword({ value: true, text: 'Requis' })
      isValid = false
    } else {
      setErrorsPassword({ value: false, text: '' })
    }

    //Vérifie que le captcha est valide
    if (!captchaValid) {
      isValid = false
      setErrorCaptcha({ value: true, text: 'Captcha requis' })
    } else {
      setErrorCaptcha({ value: false, text: '' })
    }

    return isValid
  }


  async function sendVerificationMail() {
    if (alert.value) return
    if (logIn.numero === '') { setErrorNumero({ value: true, text: 'Saisir le numero pour renvoyer la vérification' }); return }

    const body = { numero: logIn.numero }
    const result = await allActions.fetchPostAPI('api/auth/mail-verification', body, dispatch)

    //Si la requête n'a pas fonctionnné une erreur est affiché
    if (result.err) {
      setErrorForm({ value: true, text: 'Erreur: ' + result.err })
    }


    const { res, json } = result
    console.log(res)

    //Si le serveur retourne une erreur elle est affiché
    if (!res.ok) {
      setErrorForm({ value: true, text: 'Erreur: ' + json.message })
    }
    else
      setErrorForm({ value: false, text: '' })

    //Affichage de l'alerte
    enqueueSnackbar(` ${json.message}`, { variant: `${json.variant}` })
  }

  //Méthode appelée au click du bouton "Mot de passe oublié"
  async function forgotten() {

    //Vérifie que qu'il n'y a pas déjà une demande en cours
    if (alert.value) return

    let isValid = true

    //Vérifie que le numero n'est pas vide et qu'il match avec la regex numero
    if (logIn.numero === '') {
      setErrorNumero({ value: true, text: 'Requis' })
      isValid = false
    } else if (!logIn.numero.match(numeroRegex)) {
      setErrorNumero({ value: true, text: 'Le numero d\'abonné doit contenir 8 chiffres' })
      isValid = false
    } else {
      setErrorNumero({ value: false, text: '' })
    }
    if (!isValid) return


    //Appel API
    const body = { numero: logIn.numero }
    const result = await allActions.fetchPostAPI('api/users/reset-password', body, dispatch)

    //Si la requête n'a pas fonctionnné une erreur est affiché
    if (result.err) {
      setErrorForm({ value: true, text: 'Erreur: ' + result.err })
      return
    }

    const { res, json } = result
    console.log(res)

    //Si le serveur retourne une erreur elle est affiché
    if (!res.ok) {
      setErrorForm({ value: true, text: 'Erreur: ' + json.message })
      return
    }

    //Affichage de l'alerte
    enqueueSnackbar(`Un mail de réinitialisation à été envoyé`, { variant: 'info' })

  }

  useEffect(async () => {
    if (urlTokenValue) {
      const body = { token: urlTokenValue }
      const result = await allActions.fetchPostAPI('api/auth/get-info', body, dispatch)
      console.log(result)
      const { res, json } = result
      if (!res?.ok) {
        if (json?.message) {
          if (json?.code === 'user_not_found') {
            props.setTab(1);
            props.setInfo({ nom: result.json.user.lastName, prenom: result.json.user.firstName, email: result.json.user.email });
          }
          enqueueSnackbar(result.json.message, { variant: 'error' })
        }
        else
          enqueueSnackbar('Erreur lors de la récupération des informations', { variant: 'error' })
      }
      else {
        const result2 = await allActions.fetchGetAPI('api/users/modifs-infos-perso/' + json.licencie.id, dispatch, json.accessToken)
        var info = result2.json.data
        var redirectInfoPerso = true
        if (info) {
          if (info[0]?.civilite && info[0]?.nom && info[0]?.prenom && info[0]?.profession && info[1]?.date && info[2]?.adresseL1 && info[2]?.adresseNum && info[2]?.codePostal && info[2]?.ville && info[3]?.phone && info[3]?.email && info[4]?.centre) {
            dispatch(allActions.setDataCompleted(true))
            redirectInfoPerso = false
          } else
            dispatch(allActions.setDataCompleted(false))
        }

        //Mise à jour du state user Redux
        dispatch(allActions.setUser(json.licencie, json.accessToken, true))
        dispatch(allActions.logIn())

        if (redirectInfoPerso)
          history.push('/donnees-personnelles')
        else
          history.push('/')
      }
    }
  }, [urlTokenValue])

  async function handleConnexionSSO() {
    window.location.href = process.env.REACT_APP_API_PATH + 'api/auth/login-oidc'
  }

  function handleCaptchaSuccess() {
    setCaptchaValid(true)
    setErrorCaptcha({ value: false, text: '' })
  }
  function handleCaptchaError(err) {
    setCaptchaValid(false)
    setErrorCaptcha({ value: false, text: err })
  }

  return (
    <div style={{ height: '100%' }}>
      <CardContent className={classes.root}>
        <form onSubmit={submit}>
          <FormControl fullWidth={true} error={errorForm.value} className={classes.form}>
            <TextField
              error={errorNumero.value}
              helperText={errorNumero.text}
              margin="dense"
              label="Numéro d'abonné"
              variant="outlined"
              fullWidth={true}
              name="numero"
              onChange={e => handleChange(e)}
            />
            <Link style={{ cursor: 'pointer', fontSize: 13, textAlign: 'right' }} onClick={() => history.push('/numero-oublie')}>Numéro d'abonné oublié</Link>
            <TextField
              error={errorsPassword.value}
              helperText={errorsPassword.text}
              margin="dense"
              label="Mot de passe"
              type={showPassword ? 'text' : 'password'}
              variant="outlined"
              fullWidth={true}
              name="password"
              onChange={e => handleChange(e)}
              InputProps={{
                endAdornment: (
                  <InputAdornment>
                    <IconButton tabIndex="-1" onClick={() => setShowPassword(!showPassword)} size="small" >
                      {showPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />
            <Link style={{ cursor: 'pointer', fontSize: 13, textAlign: 'right' }} onClick={() => forgotten()}>Mot de passe oublié</Link>

            <Divider style={{ margin: 10 }} />
            <Link style={{ cursor: 'pointer', color: 'grey', marginBottom: 16 }} onClick={() => sendVerificationMail()}>Renvoyer mail de validation</Link>
            <HCaptcha
              sitekey={(process.env.REACT_APP_CAPTCHA_MODE === 'PROD') ? process.env.REACT_APP_KEY_CAPTCHA : process.env.REACT_APP_KEY_CAPTCHA_TEST}
              onVerify={handleCaptchaSuccess}
              onError={handleCaptchaError}
            />
            <FormHelperText style={{ color: 'red' }}>{errorCaptcha.text}</FormHelperText>
            <FormHelperText>{errorForm.text}</FormHelperText>
          </FormControl>
          <div>
            <Button color="primary" type="submit" fullWidth startIcon={<LockOpenIcon />} variant="contained" disableElevation>Se connecter</Button>
          </div>
        </form>
      </CardContent>
    </div>
  )
}
